import { useDispatch } from "react-redux";
import { PostApiData } from "../api/general";
import { ROUTES } from "../constants/api";
import { ROUTES as PAGE_ROUTES } from "../constants/clientRoutes";
import { RRAuthRequest, RRAuthResponse } from "../types/api/readyremit";
import { useHistory } from "react-router-dom";
import { SetRRAuth } from "../actions/readyRemit";
import { Dispatch, SetStateAction } from "react";
import { trackEvent } from "../services/eventTracker";

const useGetRRAuthData = ({ setLoading, openErrorModal }: { setLoading: Dispatch<SetStateAction<boolean>>, openErrorModal: Function }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const getRRAuthData = async (rsp: string, transferMethod: string, eventName?: string) => {
    setLoading(true);
    const url = ROUTES.READY_REMIT.AUTH;
    if (eventName) {
      trackEvent(eventName);
    }
    try {
      const response = await PostApiData<RRAuthRequest, RRAuthResponse>(url, {
        rsp,
        transferMethod
      });
      setLoading(false);
      if (response.result.needsToConfirmSenderDetails) {
        history.push(PAGE_ROUTES.RR_SDK.SENDER_DETAILS(rsp, transferMethod));
      } else {
        dispatch(SetRRAuth({
          encryptedAuthToken: response.result.encryptedAuthToken,
          rsp: response.result.rsp,
          transferMethod: response.result.transferMethod,
          senderId: response.result.senderId,
          balanceCheck: response.result.balanceCheck
        }))
        history.push(`${PAGE_ROUTES.RR_SDK.SDK_CONTAINER_BASE}/${response.result.rsp}/${response.result.transferMethod}`);
      }
    } catch (err) {
      setLoading(false);
      openErrorModal(err);
    }
  }

  return getRRAuthData;
};

export default useGetRRAuthData;